export const messages = {
  route_start: { id: 'towingRecord.routeMenu.start', defaultMessage: 'Lähtö' },
  route_arrival: { id: 'towingRecord.routeMenu.arrival', defaultMessage: 'Kohde' },
  route_arrival_completed: { id: 'towingRecord.routeMenu.arrivalCompleted', defaultMessage: 'Kohteessa' },
  route_finish: { id: 'towingRecord.routeMenu.finish', defaultMessage: 'Määränpää' },
  route_finish_completed: { id: 'towingRecord.routeMenu.finishCompleted', defaultMessage: 'Työ valmis' },
  route_cancelled: { id: 'towingRecord.routeMenu.cancelled', defaultMessage: 'Peruttu' },
  route_end: { id: 'towingRecord.routeMenu.end', defaultMessage: 'Lopetus' },
  route_form_selector_arrived: { id: 'towingRecord.routeFormSelector.arrived', defaultMessage: 'Saapunut' },
  route_form_selector_finished: { id: 'towingRecord.routeFormSelector.finished', defaultMessage: 'Valmis' },
}
